import React from 'react';
import './Bubble.sass';

interface IBubbleProps {
	align: string;
	text: string;
}

function Bubble(props: IBubbleProps) {
	const { align, text } = props;
	return (
		<div className={`uikit-bubble uikit-bubble--${align}`}>
			<div className="uikit-bubble__inner">{text}</div>
		</div>
	);
}

export default Bubble;
